import styled from 'styled-components';

export const MapContainer = styled.div`
  position: relative;
  display: flex;
  height: calc(100% - 4px);
  width: 100%;
  margin-top: 4px;

  .map-content {
    flex-grow: 1;

    > div:not(:fullscreen) img {
      filter: none !important;
    }
  }

  .map-metric-select {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 180px;

    .ant-select-selector {
      border-radius: 0;
    }
  }

  .gm-style-iw button.gm-ui-hover-effect {
    display: none !important;
  }
`;

export const MapTooltipContainer = styled.div`
  padding: 4px;

  .title {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.5;
    color: #000;
  }

  .content {
    margin-top: 4px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    line-height: 2;

    .label {
      display: inline-flex;
      align-items: center;
      color: #333;
      font-weight: 400;

      ::before {
        content: '';
        width: 12px;
        height: 12px;
        margin-right: 8px;
        border: 1px solid #1093f5;
        background-color: #1093f5;
      }
    }

    .value {
      display: inline-block;
      color: #666;
      margin-left: 8px;
    }
  }
`;

export const MapLoaderContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
